import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import { FormHelperText } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'block',
    marginTop: theme.spacing(2)
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  }
}))

export default function NumeroDeLoteInput (props) {
  const classes = useStyles()
  const [numeroLote, setNumeroLote] = React.useState('')
  const [open, setOpen] = React.useState(false)

  function handleChange (numeroLote) {
    setNumeroLote(numeroLote.target.value)
    props.setDatosLote(numeroLote.target.value)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  return (
    <div>

      <FormControl className={classes.formControl} error={numeroLote === ''}>
        <InputLabel id='numero-de-lote'>Ingrese LOTE</InputLabel>
        <Select
          labelId='numero-de-lote'
          id='numero-de-lote'
          open={open}
          onClose={handleClose}
          onOpen={handleOpen}
          value={numeroLote}
          onChange={handleChange}
        >
          <MenuItem value={1}>LOTE 1</MenuItem>
          <MenuItem value={2}>LOTE 2</MenuItem>
          <MenuItem value={3}>LOTE 3</MenuItem>
          <MenuItem value={4}>LOTE 4</MenuItem>
          <MenuItem value={5}>LOTE 5</MenuItem>
        </Select>
        {numeroLote === '' && <FormHelperText>Falta lote</FormHelperText>}

      </FormControl>

    </div>
  )
}
